import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import constClass from '../../Constants/Constants';
import { Link } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import { CSVLink } from "react-csv";
import Select from 'react-select';
import { useParams, generatePath } from 'react-router';
import Common from '../Common/common';
import DatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import ja from 'date-fns/locale/ja';
import InfiniteScroll from "react-infinite-scroller";
registerLocale('ja', ja);

const pageCount = 100;

const Customer = (props) => {
  const { siteId, mallId } = useParams();
  const { user, setting } = props;
  const [customerData, setCustomerData] = useState(null);
  const [customerDetailMaster, setCustomerDetailMaster] = useState(null);
  const [sortOrder, setSortOrder] = useState([]); // ソート順指定
  const [condition, setCondition] = useState({});
  const [searchFlag, setSearchFlag] = useState(false);
  // const [errMsg, setErrMsg] = useState({ postalCode: '' });
  const componentRef = useRef();
  const [csvData, setCsvData] = useState(null);
  // const [csvDetailData, setCsvDetailData] = useState(null);
  // const [csvTicketData, setCsvTicketData] = useState(null);
  // const [csvTicketDetailData, setCsvTicketDetailData] = useState(null);
  const [lineTextData, setLineTextData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const [searchLockData, setSearchLockData] = useState(false);
  // const [couponMonth, setCouponMonth] = useState(Common.getMonthString());
  const [selectedCondition, setSelectedCondition] = useState([]);
  const { addToast } = useToasts();
  const maxYear = new Date().getFullYear();
  const [page, setPage] = useState(0);
  const [customerRankData, setCustomerRankData] = useState([]);
  const [shopData, setShopData] = useState([]);
  const [mallData, setMallData] = useState([]);

  const createSearchParams = useCallback((master) => {
    var reg_params = {
      site_id: siteId,
      operator: "and",
      where: [{
        site_id: siteId
      }],
      detail_where: [],
      rank_where: [],
      mall_where: {},
    }
    Common.inputList(setting, master, customerRankData, shopData, mallData).filter(i => Object.keys(condition).includes(i.entry_type)).forEach(i => {
      const detail = i.detail_data.find(() => true);
      const where = i.data ? reg_params.detail_where : reg_params.where;
      if (detail.input_type === 'id') {
        if (condition[i.entry_type]) { // 入力値がtruthyの場合のみ
          where.push({ [i.entry_type]: Number(condition[i.entry_type]) });
        }
      } else if (detail.input_type === 'radio') {
        if (detail.entry_type === 'rank_id' && condition[i.entry_type].length > 0) {
          if (condition[i.entry_type].length < customerRankData.length) {
            // 全ランク選択されていない場合のみ絞り込み
            reg_params.rank_where = condition[i.entry_type].map( item => item.value );
          } else if (reg_params.rank_where.includes(customerRankData[0].rank_id)) { 
            reg_params.rank_where.push(null); // ランク未設定も含める
          }
        }
        else if (detail.entry_type === 'shop_id' && condition[i.entry_type].length > 0) {
        }
        else if (detail.entry_type.includes('mall_name') && condition[i.entry_type].length > 0) {
          // true or falseのためlengthが2未満の場合のみ絞り込み
          if (condition[i.entry_type].length < 2) {
            const mall_id = detail.entry_type.split('_').pop();
            reg_params.mall_where[mall_id] = condition[i.entry_type].map( item => item.value );
          }
        }
        else if (condition[i.entry_type].length > 0) {
          where.push({
            "operator": "in",
            "attr": i.entry_type,
            "val": condition[i.entry_type].map(item => item.value)
          });
        }
      } else if (detail.input_type === 'date-y') {
        if (condition[i.entry_type].start) {
          where.push({
            "operator": "gte",
            "attr": detail.entry_type,
            "val": condition[i.entry_type].start + '0000'
          });
        }
        if (condition[i.entry_type].end) {
          where.push({
            "operator": "lte",
            "attr": detail.entry_type,
            "val": condition[i.entry_type].end + '9999'
          });
        }
      } else if (detail.input_type === 'date-m') {
        if (condition[i.entry_type].length > 0) {
          where.push({
            "operator": "literal",
            "literal": `substring(${detail.entry_type}, 5, 2) in (${condition[i.entry_type].map(item => '\'' + item.value + '\'').join()})`
          });
        }
      } else if (detail.input_type === 'date-d') {
        if (condition[i.entry_type].length > 0) {
          where.push({
            "operator": "literal",
            "literal": `substring(${detail.entry_type}, 7, 2) in (${condition[i.entry_type].map(item => '\'' + item.value + '\'').join()})`
          });
        }
      } else if (detail.input_type === 'datetime') {
        if (condition[i.entry_type].start) {
          where.push({
            "operator": "gte",
            "attr": detail.entry_type,
            "val": condition[i.entry_type].start
          });
        }
        if (condition[i.entry_type].end) {
          where.push({
            "operator": "lt",
            "attr": detail.entry_type,
            "val": moment(condition[i.entry_type].end).add(1, 'days')
          });
        }
      } else if (detail.entry_type === 'point') {
      } else {
        // 部分一致
        where.push({
          "operator": "substring",
          "attr": i.entry_type,
          "val": condition[i.entry_type]
        });
      }
    });
    return reg_params;
  }, [siteId, condition, setting, customerRankData, shopData, mallData]);

  const renderData = useCallback((data, entry) => {
    const detail = entry.detail_data.find(() => true);
    const record = entry.data ? Common.getCustomerDetailObject(data[entry.data]) : data;

    if (detail.input_type === 'radio') {
      if (detail.entry_type === 'rank_id' && customerRankData.length > 0) {
        if (record.t_customer_rank[0]) {
          return customerRankData.find(i => i.rank_id === record.t_customer_rank[0].rank_id).rank_name;
        } else {
          //ランクがまだない場合最初のランク
          return customerRankData[0].rank_name;
        }
      } else if (detail.entry_type === 'shop_id' && shopData.length > 0 && mallData.length > 0 && record.t_customer_mall.length > 0) {
        const earliestShop = record.t_customer_mall.reduce((earliest, current) => {
          return new Date(current.register_date) < new Date(earliest.register_date) ? current : earliest;
        });
        if (earliestShop.shop_id && earliestShop.mall_id) {
          const shop = shopData.find(i => i.shop_id === earliestShop.shop_id);
          const mall = mallData.find(m => m.mall_id === earliestShop.mall_id);
          return `${shop.shop_name}(${mall.mall_name})`;
        }
      } else if (detail.entry_type.includes('mall_name')) {
        return !record.t_customer_mall.find(t => t.mall_id === detail.key) ? '-' : record.t_customer_mall.find(t => t.mall_id === detail.key).agreement === constClass.FLAG.ON ? '〇' : '-';
      } else {
        return entry.detail_data.find(d => d.entry_data === record[entry.entry_type]) ?
          entry.detail_data.find(d => d.entry_data === record[entry.entry_type]).entry_name : '';
      }
    } else if (detail.input_type === 'datetime') {
      return moment(record[entry.entry_type]).isValid() ? moment(record[entry.entry_type]).format("YYYY/MM/DD HH:mm:ss") : '';
    } else if (detail.input_type === 'date') {
      return Common.getDateObject(record[entry.entry_type]).str;
    } else if (detail.input_type === 'date-y') {
      return Common.getDateObject(record[detail.entry_type]).year || '';
    } else if (detail.input_type === 'date-m') {
      return Common.getDateObject(record[detail.entry_type]).month || '';
    } else if (detail.input_type === 'date-d') {
      return Common.getDateObject(record[detail.entry_type]).date || '';
    } else if (detail.input_type === 'number' && detail.entry_type === 'point') {
      return record[entry.entry_type] ? record[entry.entry_type] : 0;
    } else {
      return record[entry.entry_type];
    }
  }, [customerRankData, shopData, mallData]);

  const createCsvData = useCallback((data, master, customerrankdata, shopdata, malldata) => {
    const list = [];
    const head = Common.inputList(setting, master, customerrankdata, shopdata, malldata).map(i => ({ label: i.entry_type_short_name, key: i.entry_type }));
    head.push({ label: "LINE_ID", key: "line_id" });
    data.forEach(c => {
      var customer = { line_id: c.line_id };
      Common.inputList(setting, master, customerrankdata, shopdata, malldata).forEach(i => {
        customer[i.entry_type] = renderData(c, i);
      });
      list.push(customer);
    });
    setCsvData({ header: head, list: list });
  }, [setting, renderData]);

  const refreshMaster = useCallback(async () => {
    setSearchFlag(true);
    setSearchLockData(true);
    const jwt = localStorage.getItem('jwt');

    var params = { site_id: siteId };
    const customerrankPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/search`, params, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    });
    const shopPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/shop/${siteId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    });
    const mallPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/mall/${siteId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    });
    const masterPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/customerdetail/${siteId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    });
    const customerrankdata = (await customerrankPromise).data;
    customerrankdata.sort((a, b) => a.point_lower - b.point_lower)
    setCustomerRankData(customerrankdata);
    const shopdata = (await shopPromise).data;
    setShopData(shopdata);
    const malldata = (await mallPromise).data;
    setMallData(malldata);
    // お客様詳細マスタ
    const master = (await masterPromise).data;
    setCustomerDetailMaster(master);
    setSearchLockData(false);
    setSearchFlag(false);
  }, [siteId]);

  const refreshCustomer = useCallback(async () => {
    if (setting) {
      // useCallback対応のため検索ボタンを押したときのみ実行
      if (searchFlag && !searchLockData) {
        setSearchLockData(true);
        setCustomerData(null);
        const jwt = localStorage.getItem('jwt');

        const reg_params = createSearchParams(customerDetailMaster);
        // お客様データ
        var data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/search_backyard/`, reg_params, {
          headers: {
            Authorization: `Bearer ${jwt}`,
          }
        })).data;
        Common.inputList(setting, customerDetailMaster, customerRankData, shopData, mallData).filter(c => Object.keys(condition).includes(c.entry_type)).forEach(i => {
          if (i.entry_type.includes('mall_name') && condition[i.entry_type].length > 0) {
            var key = i.entry_type.split('_').pop();
            data = data.filter(d => {
              const hasMallData = d.t_customer_mall && d.t_customer_mall.length > 0;
              const hasMatchingKey = hasMallData && d.t_customer_mall.some(t => t.mall_id === Number(key));
              if (condition[i.entry_type].map(item => item.value).includes("1") && condition[i.entry_type].map(item => item.value).includes("0")){
                return true;
              } 
              else if (condition[i.entry_type].map(item => item.value).includes("1")) {                
                return hasMatchingKey && d.t_customer_mall.some(t => t.mall_id === Number(key) && t.agreement.toString() === "1");
              } else if (hasMatchingKey && condition[i.entry_type].map(item => item.value).includes("0")) {
                return !hasMallData || d.t_customer_mall.some(t => t.mall_id === Number(key) && t.agreement.toString() === "0");
              }
              return true;
            });
          }
          if (i.entry_type.includes('shop_id') && shopData.length > 0 && condition[i.entry_type].length > 0) {
            data = data.filter(d => d.t_customer_mall.some(t => condition[i.entry_type].map(item => item.value).includes(d.t_customer_mall.reduce((earliest, current) => new Date(current.register_date) < new Date(earliest.register_date) ? current : earliest).shop_id)));
          }
          if (i.entry_type.includes('rank_id') && customerRankData.length > 0 && condition[i.entry_type].length > 0) {
            data = data.filter(d => {
              if (d.t_customer_rank && d.t_customer_rank.length > 0) {
                return d.t_customer_rank.some(t => condition[i.entry_type].map(item => item.value).includes(t.rank_id));
              } else {
                return condition[i.entry_type].map(item => item.value).includes(customerRankData[0].rank_id);
              }
            });
          }
          if (i.entry_type.includes('point') && condition[i.entry_type]) {
            if (condition[i.entry_type].start) {
              data = data.filter(d => condition[i.entry_type].start <= (d.point ? d.point : 0));
            }
            if (condition[i.entry_type].end) {
              data = data.filter(d => (d.point ? d.point : 0) <= condition[i.entry_type].end);
            }
          }
        });
        setCustomerData(data);
        createLineTextData(data);
        setSearchLockData(false);
      }
      setSearchFlag(false);
    }
  }, [searchFlag, shopData, createSearchParams, customerRankData, setting, condition, searchLockData, customerDetailMaster, mallData]);

  const handleHeaderClick = (column, detail) => {
    var _sortOrder = sortOrder;
    if (_sortOrder.map(s => s.column).includes(column)) { // 既に登録済み
      if (_sortOrder[0].column !== column) { // 先頭ではない
        _sortOrder.splice(_sortOrder.findIndex(s => s.column === column), 1); //削除
        _sortOrder.unshift({ column, detail, order: 'ASC' }); // 追加
      } else { //先頭 並び順変更
        _sortOrder[0].order = _sortOrder[0].order === 'ASC' ? 'DESC' : 'ASC';
      }
    } else { //未登録
      _sortOrder.unshift({ column, detail, order: 'ASC' }); // 追加
    }
    if (_sortOrder.length > 3) { //ソート順は3件まで
      _sortOrder.pop();
    }
    setSortOrder(_sortOrder);
    var data = customerData.slice();
    data.sort((a, b) => sortData(a, b));
    setCustomerData(data);
  }

  /* 退会処理 */
  const handleCancelClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`お客様No[${data.customer_id}]を退会済みにします。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      status: constClass.STATUS.CCL,
      // payment_status: constClass.PAYMENT_STATUS.CCL, // 決済停止中
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/status/${data.customer_id}`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
      if (res && res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      }
      else {
        addToast('更新しました。', { appearance: 'success', autoDismiss: true });
      }
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      setSearchFlag(true);
      setLockData(false);
    }
  }

  /* 退会取消処理 */
  const handleRegisterClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`お客様ID[${data.customer_id}]の退会を取り消します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      status: constClass.STATUS.REG,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/status/${data.customer_id}`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
      if (res && res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      }
      else {
        addToast('更新しました。', { appearance: 'success', autoDismiss: true });
      }
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      setSearchFlag(true);
      setLockData(false);
    }
  }

  const handleChangeSelectedCondition = (data) => {
    var temp = { ...condition };
    // 追加された項目の初期値を設定する
    data.forEach(d => {
      const entry = Common.inputList(setting, customerDetailMaster, customerRankData, shopData, mallData).find(i => i.entry_type === d.value);
      const detail = entry.detail_data.find(() => true);
      if (detail.input_type === 'radio' || detail.input_type === 'date-m' || detail.input_type === 'date-d') {
        temp = { [entry.entry_type]: [], ...condition };
      } else if (detail.input_type === 'date-y' || detail.input_type === 'datetime') {
        temp = { [entry.entry_type]: { start: '', end: '' }, ...condition };
      } else {
        temp = { [entry.entry_type]: '', ...condition };
      }
    });
    // 削除された項目を検索条件から外す
    Object.keys(condition).filter(c => !data.map(d => d.value).includes(c)).forEach(c => {
      delete temp[c];
    })
    setCondition(temp);
    setSelectedCondition(data);
  }

  const handleSelect = (column) => (data) => {
    if (data.length <= 0) {
      setCondition({ ...condition, [column]: [] });
    } else {
      setCondition({ ...condition, [column]: data });
    }
  }

  const handleChangeYear = (range) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setCondition({ ...condition, [name]: { ...condition[name], [range]: value } });
  }

  const handleChangeDate = (name, values) => {
    const [start, end] = values;
    setCondition({ ...condition, [name]: { start: start, end: end } });
  }

  const handleChangeCondition = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setCondition({ ...condition, [name]: value });
    // setErrMsg({ ...errMsg, [name]: validator(name, value) });
  }

  // const validator = (name, value) => {
  //   switch (name) {
  //     case 'birth-y':
  //       return yearValidation(value);
  //     case 'postalCode':
  //       return postalCodeValidation(value);
  //     default:
  //       return '';
  //   }
  // }

  // const yearValidation = (value) => {
  //   if (value === '') return '';
  //   const regex = /^[0-9]{4}$/;
  //   if (!regex.test(value)) return '※正しい形式で年を入力してください';
  //   return '';
  // }

  // const postalCodeValidation = (value) => {
  //   if (value === '') return '';
  //   const regex = /^[0-9]{0,7}$/;
  //   if (!regex.test(value)) return '※正しい形式で郵便番号を入力してください';
  //   return '';
  // }

  const sortData = (a, b) => {
    if (sortOrder.length <= 0) { // 初期値はお客様ID
      return Number(a.customer_id) - Number(b.customer_id);
    }
    for (var i = 0; i < sortOrder.length; i++) {
      const item = sortOrder[i];
      const detail = item.detail.find(() => true);
      // ランク情報のソート
      if (item.column === 'rank_id') {
        const aRankId = a.t_customer_rank[0] ? a.t_customer_rank[0].rank_id : 0;
        const bRankId = b.t_customer_rank[0] ? b.t_customer_rank[0].rank_id : 0;
        if (item.order === 'ASC') {
          return aRankId - bRankId;
        } else {
          return bRankId - aRankId;
        }
      }
      // 登録店舗のソート
      if (item.column === 'shop_id') {
        const aShopId = a.t_customer_mall[0] ? a.t_customer_mall[0].shop_id : 0;
        const bShopId = b.t_customer_mall[0] ? b.t_customer_mall[0].shop_id : 0;
        if (item.order === 'ASC') {
          return aShopId - bShopId;
        } else {
          return bShopId - aShopId;
        }
      }
      // mall_idのソート
      if (item.column.startsWith('mall_name_')) {
        const mallId = item.column.split('_')[2]; // mall_idを取得
        const aMallId = a.t_customer_mall.find(mall => mall.mall_id === Number(mallId)) ? 1 : 0;
        const bMallId = b.t_customer_mall.find(mall => mall.mall_id === Number(mallId)) ? 1 : 0;
        if (item.order === 'ASC') {
          return aMallId - bMallId;
        } else {
          return bMallId - aMallId;
        }
      }
      // 既存のソート処理
      if (detail.input_type === 'radio') {
        const aData = item.detail.find(d => d.entry_data === a[item.column]) ? item.detail.find(d => d.entry_data === a[item.column]).entry_seq : 0;
        const bData = item.detail.find(d => d.entry_data === b[item.column]) ? item.detail.find(d => d.entry_data === b[item.column]).entry_seq : 0;
        if (item.order === 'ASC') {
          if (aData < bData) return -1;
          if (aData > bData) return 1;
        } else {
          if (bData < aData) return -1;
          if (bData > aData) return 1;
        }
      } else if (detail.input_type === 'id') {
        if (item.order === 'ASC') {
          if (Number(a[item.column]) < Number(b[item.column])) return -1;
          if (Number(a[item.column]) > Number(b[item.column])) return 1;
        } else {
          if (Number(b[item.column]) < Number(a[item.column])) return -1;
          if (Number(b[item.column]) > Number(a[item.column])) return 1;
        }
      } else if (['date-y', 'date-m', 'date-d'].includes(detail.input_type)) {
        const start = detail.input_type === 'date-y' ? 0 : detail.input_type === 'date-m' ? 4 : 6;
        const end = detail.input_type === 'date-y' ? 4 : detail.input_type === 'date-m' ? 6 : 8;
        const aData = Number(a[detail.entry_type] ? a[detail.entry_type].slice(start, end) : 0);
        const bData = Number(b[detail.entry_type] ? b[detail.entry_type].slice(start, end) : 0);
        if (item.order === 'ASC') {
          if (aData < bData) return -1;
          if (aData > bData) return 1;
        } else {
          if (bData < aData) return -1;
          if (bData > aData) return 1;
        }
      } else {
        if (item.order === 'ASC') {
          if (a[item.column] < b[item.column]) return -1;
          if (a[item.column] > b[item.column]) return 1;
        } else {
          if (b[item.column] < a[item.column]) return -1;
          if (b[item.column] > a[item.column]) return 1;
        }
      }
    }
    return 0;
  }

  const createLineTextData = (data) => {
    const list = data.map(c => [c.line_id]);
    setLineTextData({ list: list });
  }

  const renderSortTh = (column, detail) =>
    <th className="text-center align-middle like-button p-0 m-0" onClick={() => handleHeaderClick(column, detail)} key={column}>
      {sortOrder.filter(s => s.column === column).map((item, idx, self) =>
        <span key={idx}>{item.order === 'ASC' ? '▲' : '▼'}{sortOrder.findIndex(s => s.column === column) + 1}</span>
      )}
    </th>

  const renderCancelButton = (data) => {
    return (
      <button
        className={`btn btn-secondary mx-1 text-nowrap`}
        disabled={lockData}
        onClick={() => handleCancelClick(data)}>
        退会
      </button>
    )
  }

  const renderRegisterButton = (data) => {
    return (
      <button
        className={`btn btn-secondary mx-1 px-0`}
        disabled={lockData}
        onClick={() => handleRegisterClick(data)}>
        退会取消
      </button>
    )
  }

  useEffect(() => {
    refreshCustomer();
  }, [refreshCustomer]);

  useEffect(() => {
    refreshMaster();
  }, [refreshMaster]);

  useEffect(() => {
    if (customerData !== null && customerDetailMaster !== null && customerRankData.length > 0 && shopData.length > 0 && mallData.length > 0) {
      createCsvData(customerData, customerDetailMaster, customerRankData, shopData, mallData);
    }
  }, [customerRankData, customerData, customerDetailMaster, shopData, mallData, createCsvData]);

  // useEffect(() => {
  //   refreshCoupon();
  // }, [refreshCoupon]);

  return (
    <div className="container">
      <div className="row mx-0 my-2 px-1-env">
        <div className="col-2 px-0">
          {setting &&
            <Select
              styles={{ container: (base) => ({ ...base, zIndex: 600 }) }}
              options={Common.inputList(setting, customerDetailMaster, customerRankData, shopData, mallData).map(i => ({ value: i.entry_type, label: i.entry_type_short_name }))}
              isClearable={false}
              isMulti
              closeMenuOnSelect={false}
              value={selectedCondition}
              placeholder={'検索条件...'}
              backspaceRemovesValue={false}
              controlShouldRenderValue={false}
              hideSelectedOptions={false}
              onChange={handleChangeSelectedCondition} />
          }
        </div>
        <div className="col-9">
          <div className="row my-1">
            {setting && selectedCondition.map(c => {
              const entry = Common.inputList(setting, customerDetailMaster, customerRankData, shopData, mallData).find(i => i.entry_type === c.value);
              const detail = entry.detail_data.find(() => true);
              return entry && <div className="col-4" key={c.value}>
                <div className="row">
                  <div className="col-auto pr-0 text-center align-self-center">
                    <span>{entry.entry_type_short_name}</span>
                  </div>
                  {detail.input_type === 'text' &&
                    <div className="col text-center">
                      <input className={`form-control`} type="text" id={entry.entry_type} name={entry.entry_type} value={condition[entry.entry_type]} onChange={handleChangeCondition}></input>
                    </div>
                  }
                  {detail.input_type === 'number' && detail.entry_type === 'point' &&
                    <React.Fragment>
                      <div className="col pr-0 text-center">
                        <input className={`form-control`} type="number" id={entry.entry_type + '-start'} name={entry.entry_type} value={condition[entry.entry_type].start} onChange={handleChangeYear('start')} max={maxYear}></input>
                      </div>
                      <div className="col-auto px-0 text-center align-self-center">
                        <span>～</span>
                      </div>
                      <div className="col pl-0 text-center">
                        <input className={`form-control`} type="number" id={entry.entry_type + '-end'} name={entry.entry_type} value={condition[entry.entry_type].end} onChange={handleChangeYear('end')} max={maxYear}></input>
                      </div>
                    </React.Fragment>
                  }
                  {detail.input_type === 'number' && detail.entry_type !== 'point' && 
                    <div className="col text-center">
                      <input className={`form-control`} type="number" id={entry.entry_type} name={entry.entry_type} value={condition[entry.entry_type]} onChange={handleChangeCondition}></input>
                    </div>
                  }
                  {detail.input_type === 'id' &&
                    <div className="col text-center">
                      <input className={`form-control`} type="number" id={entry.entry_type} name={entry.entry_type} value={condition[entry.entry_type]} onChange={handleChangeCondition}></input>
                    </div>
                  }
                  {detail.input_type === 'radio' &&
                    <div className="col text-center">
                      <Select
                        styles={{ container: (base) => ({ ...base, zIndex: 600 }) }}
                        options={entry.detail_data.map(d => ({ value: d.entry_data, label: (d.entry_name === constClass.FLAG.ON) ? '〇' : (d.entry_name === constClass.FLAG.OFF) ? '-' : d.entry_name }))}
                        isClearable={false}
                        isMulti
                        closeMenuOnSelect={false}
                        value={condition[entry.entry_type]}
                        onChange={handleSelect(entry.entry_type)} />
                    </div>
                  }
                  {detail.input_type === 'date-y' &&
                    <React.Fragment>
                      <div className="col pr-0 text-center">
                        <input className={`form-control`} type="number" id={entry.entry_type + '-start'} name={entry.entry_type} value={condition[entry.entry_type].start} onChange={handleChangeYear('start')} max={maxYear}></input>
                      </div>
                      <div className="col-auto px-0 text-center align-self-center">
                        <span>～</span>
                      </div>
                      <div className="col pl-0 text-center">
                        <input className={`form-control`} type="number" id={entry.entry_type + '-end'} name={entry.entry_type} value={condition[entry.entry_type].end} onChange={handleChangeYear('end')} max={maxYear}></input>
                      </div>
                    </React.Fragment>
                  }
                  {detail.input_type === 'date-m' &&
                    <div className="col text-center">
                      <Select
                        styles={{ container: (base) => ({ ...base, zIndex: 600 }) }}
                        options={[...Array(12)].map((_, i) => ({ value: ('00' + (i + 1)).slice(-2), label: i + 1 }))}
                        isClearable={false}
                        isMulti
                        closeMenuOnSelect={false}
                        value={condition[entry.entry_type]}
                        onChange={handleSelect(entry.entry_type)} />
                    </div>
                  }
                  {detail.input_type === 'date-d' &&
                    <div className="col text-center">
                      <Select
                        styles={{ container: (base) => ({ ...base, zIndex: 600 }) }}
                        options={[...Array(31)].map((_, i) => ({ value: ('00' + (i + 1)).slice(-2), label: i + 1 }))}
                        isClearable={false}
                        isMulti
                        closeMenuOnSelect={false}
                        value={condition[entry.entry_type]}
                        onChange={handleSelect(entry.entry_type)} />
                    </div>
                  }
                  {detail.input_type === 'datetime' &&
                    <div className="col text-center">
                      <DatePicker className="custom-select text-left border-textbox"
                        locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={entry.entry_type} name={entry.entry_type}
                        popperPlacement='bottom'
                        selected={condition[entry.entry_type].start}
                        onChange={value => handleChangeDate(entry.entry_type, value)}
                        startDate={condition[entry.entry_type].start}
                        endDate={condition[entry.entry_type].end}
                        placeholderText="- 選択 -"
                        selectsRange
                        onFocus={(e) => e.target.blur()}
                      />
                    </div>
                  }
                </div>
              </div>
            })}
          </div>
        </div>
        <div className="col-1 text-center">
          <button type="button"
            disabled={searchLockData}
            className={`btn btn-primary mx-1 w-100`}
            onClick={() => setSearchFlag(true)}>
            検索</button>
        </div>
      </div>
      {(searchLockData && (customerData === null || mallData === null)) && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {customerData !== null && mallData !== null && (
        <div ref={componentRef} className="print-list">
          <div className="row mb-0 p-0 ">
            <div className="col-10 pl-0 text-left align-self-end">
              <div className="row mr-0">
                <div className="col-2 pr-2 align-self-center">
                  {customerData[0] &&
                    <ReactToPrint
                      trigger={() => (
                        <button type="button" className="btn btn-primary print-none px-0 mb-1 w-100">
                          一覧表印刷
                        </button>
                      )}
                      content={() => componentRef.current}
                      pageStyle={""}
                    />}
                </div>
                <div className="col-2 px-2 align-self-center">
                  {csvData &&
                    <CSVLink className="btn btn-primary print-none mb-1 px-0 w-100" data={csvData.list} headers={csvData.header} filename={"お客様一覧.csv"}>
                      一覧表CSV出力
                    </CSVLink>
                  }
                </div>
                <div className="col-2 px-2 align-self-center">
                  {lineTextData &&
                    <CSVLink className="btn btn-primary print-none mb-1 px-0 w-100" data={lineTextData.list} filename={"LINE通知用ユーザID一覧.csv"} enclosingCharacter={""}>
                      ユーザID出力
                    </CSVLink>
                  }
                </div>
              </div>
            </div>
            <div className="col-2 px-2 align-self-center text-right border h-100">
              <div className="row">
                <div className="col-auto py-1 px-2 bg-lightwhite h-100">一覧表件数</div>
                <div className="col py-1">{customerData.length.toLocaleString()}</div>
              </div>
            </div>
          </div>
          <div className="row mb-3 p-0">
            <div className="col-12 p-0">
              <InfiniteScroll
                loadMore={(p) => setPage(Number(p) * pageCount)}    //項目を読み込む際に処理するコールバック関数 
                hasMore={(customerData.length > page)}         //読み込みを行うかどうかの判定
                loader={<div key={-1}>{customerData.length}件中 {page + pageCount}件まで表示中（スクロールで読み込み）</div>}       //読み込み最中に表示する項目
              >
                <table className="table table-bordered table-striped" height="1">
                  <thead className={`table-info`}>
                    <tr>
                      {Common.inputList(setting, customerDetailMaster, customerRankData, shopData, mallData).map(i =>
                        <th className={`text-center align-middle text-nowrap like-button ${i.entry_type.includes('mall_name') ? 'print-none' : ''}`} onClick={() => handleHeaderClick(i.entry_type, i.detail_data)} key={i.entry_type}>
                          {i.entry_type.includes('mall_name') || i.entry_type === "birth-y" || i.entry_type === "birth-m" || i.entry_type === "birth-d" ? Common.formatName(i.entry_type_short_name) : i.entry_type_short_name}
                        </th>
                      )}
                      {(user.userClass === constClass.USER_CLASS.MANAGERMALL && Common.getFunctionEnabled(setting, 'CANCEL')) &&
                        <th className="text-center align-middle">
                          処理
                        </th>
                      }
                    </tr>
                    <tr className="print-none">
                      {Common.inputList(setting, customerDetailMaster, customerRankData, shopData, mallData).map(i =>
                        renderSortTh(i.entry_type, i.detail_data)
                      )}
                      {(user.userClass === constClass.USER_CLASS.MANAGERMALL && Common.getFunctionEnabled(setting, 'CANCEL')) && <th></th>}
                    </tr>
                  </thead>
                  <tbody>
                    {customerData.map((data, idx) => (idx < (page + pageCount) &&
                      <tr key={data.customer_id}>
                        {Common.inputList(setting, customerDetailMaster, customerRankData, shopData, mallData).map(i => {
                          return (
                            <td className={`text-center align-middle p-1 ${i.entry_type.includes('mall_name') ? 'print-none' : ''}`} key={`${i.entry_type}-${data.customer_id}`}>
                              {i.entry_type === 'customer_id' ? (
                                <Link to={`${generatePath(`${props.match.path}`, { siteId, mallId })}customer/${data.customer_id}`}>
                                  {renderData(data, i)}
                                </Link>
                              ) : (
                                renderData(data, i)
                              )}
                            </td>
                          );
                        })}
                        {/* 処理 */}
                        {(user.userClass === constClass.USER_CLASS.MANAGERMALL && Common.getFunctionEnabled(setting, 'CANCEL')) &&
                          <td className="text-center align-middle p-1">
                            {data.status === constClass.STATUS.REG && renderCancelButton(data)}
                            {data.status === constClass.STATUS.CCL && renderRegisterButton(data)}
                          </td>
                        }
                      </tr>
                    ))
                    }
                  </tbody>
                </table>
              </InfiniteScroll>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Customer;